module.exports = __webpack_public_path__ + "img/tiktok-shop.40e3bc84.png";